import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import DataGrid from 'app/components/DataGrid';
import useResource from 'app/hooks/useResource';
import BillingExportScheduleModal from './BillingExportScheduleModal';

import {
  getBillingExportScheds,
  setBillingExportSchedParams
} from 'app/actions/billings';

import {
  createBillingExportSched,
  updateBillingExportSched
} from 'app/services/billings';

import {
  billingExportSched as resource
} from 'app/resources';

import {
  getAccounts
} from 'app/services/accounts';

import {
  formatPascalCase
} from 'app/utils/valueFormatters';

import {
  formatOptions,
  scheduleOptions
} from 'app/utils/options';

export const BillingExportSchedule = (props) => {
  const { getBillingExportScheds, setBillingExportSchedParams } = props;

  // load needed resources on first render
  const [accounts, setAccounts] = useState([]);
  useEffect(() => {
  getAccounts({ page: 1, per_page: 100 })
    .then(resp => setAccounts(resp.records));
  }, []);

  const header = 'Export Schedules';
  const getRowData = getBillingExportScheds;
  const addButtonLabel = 'Add Export Schedule';
  const columnOrder = ['export_name', 'schedule_type', 'account_id', 'start_date', 'end_date', 'email'];
  const visibleColumns = columnOrder;
  const accountOptions = formatOptions(accounts);

  const {
    onAdd,
    onEdit,
    onQuickAdd,
    onQuickEdit,
    formIsOpen,
    currentRecord,
    onDataGridLoad,
    onFormSubmit,
    onFormClose,
    showFilters
  } = useResource({
    resource,
    getResource: getBillingExportScheds,
    createResource: createBillingExportSched,
    updateResource: updateBillingExportSched,
    setResourceParams: setBillingExportSchedParams,
  });

  const columnDefOverrides = visibleColumns.map((col) => {
    if (col === 'schedule_type') {
      return {
        field: 'schedule_type',
        headerName: 'Schedule Type',
        dataValueFormatter: (data, value) => {
          return scheduleOptions.find((i) => i.value === data.schedule_type)?.label;
        },
        quickEdit: true,
        inputType: 'select',
        inputOptions: scheduleOptions
      }
    } else if (col === 'account_id') {
      return {
        field: 'account_id',
        headerName: 'Account Name',
        dataValueFormatter: (data, value) => {
          let account;
          if (data.account_id === -1){
            return 'All Accounts'
          } else {
            account = accountOptions.find((i) => i.value === data.account_id)?.label
          }

          return account || null;
        },
        quickEdit: true,
        inputType: 'select',
        inputOptions: accountOptions
      }
    } else {
      return {
        field: col,
        quickEdit: true,
        headerName: formatPascalCase(col)
      }
    }
  })

  return <div>
  <DataGrid
    resource={resource}
    header={header}
    getRowData={getRowData}
    addButtonLabel={addButtonLabel}
    onAdd={onAdd}
    showEdit={true}
    onEdit={onEdit}
    showQuickEdit={true}
    onDataGridLoad={onDataGridLoad}
    showSelect={true}
    loadingMessage="Loading billings..."
    columnOrder={columnOrder}
    visibleColumns={visibleColumns}
    columnDefOverrides={columnDefOverrides}
  />
  <BillingExportScheduleModal
    isOpen={formIsOpen}
    onClose={onFormClose}
    exportSched={currentRecord}
    onFormSubmit={onFormSubmit}
    accounts={accounts}
  />
  </div>
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, { getBillingExportScheds, setBillingExportSchedParams })(withRouter(BillingExportSchedule));
